import { render, staticRenderFns } from "./BlockListItem.vue?vue&type=template&id=2e397aed&scoped=true&"
import script from "./BlockListItem.vue?vue&type=script&lang=ts&"
export * from "./BlockListItem.vue?vue&type=script&lang=ts&"
import style0 from "./BlockListItem.vue?vue&type=style&index=0&id=2e397aed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e397aed",
  null
  
)

export default component.exports